import React, { PureComponent } from 'react';
import axios from 'axios';

import share from '../images/share.jpg';

class Share extends PureComponent {
    state = {
        shareMessage: null
    }

    componentDidMount() {
        this.getShareMessage();
    }

    async getShareMessage() {
        const response = await axios.get(process.env.CMS_URL + '/getOptions');
        const shareMessage = response.data.share_message;

        this.setState({
            shareMessage
        });
    }

    render() {
        const { isShareOpen } = this.props;
        const { shareMessage } = this.state;

        return (
            <span>
                { shareMessage && (
                    <div className={isShareOpen ? 'share __active' : 'share'} style={{ backgroundImage: `url(${share})` }}>
                        <h2 className="share-title">
                                Share this quiz with your<br/>
                                colleagues and friends
                        </h2>
                        <div className="share-icons">
                            <div className="shareicons">
                                <div className="row no-gutters">
                                    <div className="col-auto">
                                        <a target="_blank" className="shareicon __tw" href={ `https://twitter.com/home?status=${window.location.href}` } />
                                    </div>
                                    <div className="col-auto">
                                        <a target="_blank" className="shareicon __fb" href={ `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}` } />
                                    </div>
                                    <div className="col-auto">
                                        <a target="_blank" className="shareicon __in" href={ `https://www.linkedin.com/shareArticle?mini=true&url=&title=Cardiff%20University%20Quiz&summary=${shareMessage}` }  />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </span>
        );
    }
}

export default Share;



// WEBPACK FOOTER //
// ./src/Results/Share.js